<template>
  <div class="tab-pane" id="dtab3" role="tabpanel">
    <div class="mb-3">
      <h3>Personal</h3>
      <div class="switch">
        <label class="w-100"> Personal anzeigen

          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100 pl-2"> Summen rechts anzeigen
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <div class="switch">
        <label class="w-100 pl-2"> Summen unten anzeigen
          <input type="checkbox">
          <span class="lever float-right mr-0"></span>
        </label>
      </div>

      <p class="mt-3">Firmenliste</p>
      <div class="search-bar">
        <div class="form-group doc-search">
          <input type="text" class="form-control" placeholder="Firma suchen">
          <img class="form-control-feedback search-img" src="@/assets/images/search.png" alt="search-icon">
        </div>
      </div>

      <div class="kwords">
        <span class="chip">HSM Baumanagement</span>
        <span class="chip">projectdocu</span>
        <span class="chip">Otto Bau</span>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/ConstructionStaffTab.vue